import Act from '../actions';

const initState = {};

const userReducer = (state = initState, action) => {
	switch (action.type) {
		case Act.FIREBASE_LOGIN_USER:
			return { ...state, ...action.payload };
		case Act.FIREBASE_LOGOUT_USER:
			return {};
		default:
			return state;
	}
};

export default userReducer;
